import api from "./api";

export const profitLossService = {

  getAllProfitLoss: async (params = {}) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/get-single-bike-profit-loss?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getSpecificProfitLoss: async (id) => {
    try {
      const response = await api.get(`/get-specific-bike-profit-loss/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // ✅ Add a due instalment payment for a sale
  addPayment: async (saleId, payload) => {
    try {
      // payload: { amount: Number, date: String, note?: String }
      const response = await api.post(`/add-payment/${saleId}`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
transferCostService: async (params) => {
    try {
      const query = new URLSearchParams(params).toString();
      const response = await api.get(`/get-transfer-cost?${query}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

};